// src/services/authProvisioning.js
//
// Thin client for the staff-provisioning Cloud Functions. Creating the Firebase
// Auth account requires the Admin SDK, so it must happen server-side; this just
// calls createStaffUser with the caller's ID token (the function checks that the
// caller is an owner or tenant admin before doing anything).

import { auth } from "../firebase";
import { FUNCTIONS_BASE } from "../config/functionsBase";

const CREATE_STAFF_USER_URL =
  `${FUNCTIONS_BASE}/createStaffUser`;

/**
 * Create (or re-invite) a staff member's login and email them a set-password
 * link. Idempotent: if the account already exists, the server just re-sends the
 * link, so this doubles as "resend invite". Returns { created } on success.
 */
export async function inviteStaffUser(email) {
  const user = auth.currentUser;
  if (!user) throw new Error("You must be signed in to invite users.");
  const idToken = await user.getIdToken();
  const resp = await fetch(CREATE_STAFF_USER_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ email: String(email || "").trim().toLowerCase() }),
  });
  if (!resp.ok) {
    const data = await resp.json().catch(() => ({}));
    throw new Error(data.error || "Could not send the invite.");
  }
  return resp.json();
}
